<template>
    <div
        v-if="offer"
        class="offer offer--market"
        :class="[offer.offerType, offer.state]"
        :id="'offer-' + offer.id"
    >
        <div class="offer__header" @click="toggleOfferId(offer.id, '')">
            <div class="header-part">
                <span data-test="offer-idMarket" class="offer-id">
                    #{{ offer.id }}
                </span>
                <span class="part-name">
                    <span v-if="!offer.displayName">
                        {{ offer.organization.businessName }}
                    </span>
                    <span v-else>
                        {{ offer.displayName }} -
                        <span class="part-location">
                            {{ offerLocation }}
                        </span>
                    </span>
                </span>
            </div>

            <div
                v-if="!showConfirmation"
                class="header-actions"
                :class="{ hidden: offerId }"
            >
                <template v-if="offerAction === ''">
                    <button
                        data-test="button-negotiation"
                        v-if="
                            hasAnyTrue(offer.negotiableAttributes) &&
                            userCanOperate(offer)
                        "
                        class="btn btn--small negotiate"
                        type="flat"
                        icon="close"
                        @click.stop="toggleOfferId(offer.id, 'negotiate')"
                    >
                        Negociar
                    </button>

                    <button
                        v-if="userCanOperate(offer)"
                        data-test="button-buy"
                        class="btn btn--small"
                        :class="
                            offer.offerType === 'open_buy' ? 'seller' : 'buyer'
                        "
                        @click.stop="
                            offer.offerType === 'open_buy' || offer.offerType
                                ? toggleOfferId(offer.id, 'operate', 'sell')
                                : toggleOfferId(offer.id, 'operate', 'buy')
                        "
                    >
                        {{
                            offer.offerType === "open_buy" ||
                            offer.offerType === "direct_buy"
                                ? "Vender"
                                : "Comprar"
                        }}
                    </button>
                    <button
                        class="btn btn--small"
                        :class="
                            offer.offerType === 'open_buy' ? 'seller' : 'buyer'
                        "
                        @click.stop="
                            offer.offerType === 'open_buy' || offer.offerType
                                ? toggleOfferId(offer.id, 'operate', 'sell')
                                : toggleOfferId(offer.id, 'operate', 'buy')
                        "
                        v-else
                    >
                        Ver más
                    </button>
                </template>
                <template v-else>
                    <button class="close" @click="offerId = ''">
                        <vs-icon icon="close" />
                    </button>
                </template>
            </div>
        </div>
        <div class="offer__content">
            <!-- <div v-if="showConfirmation" class="px-3 py-2">
        <div class="py-1 font-italic">
          <vs-icon icon="lens" class="font-size-12-px color-item-offer"/>
          Por favor verifique los datos de la operación antes de Confirmar. <br>
          <vs-icon icon="lens" class="font-size-12-px color-item-offer"/>
          La contraparte también deberá Confirmarla. <br>
          <vs-icon icon="lens" class="font-size-12-px color-item-offer"/>
          Tiene tiempo para cancelar la operación, hasta que la contraparte también la confirme.
        </div>

        <div class="offer__actions d-flex justify-content-end">
          <button class="btn btn-secondary mr-2" @click.stop="showPopupConfirmation">
            Cancelar
          </button>

          <button data-test="button-buy"
                  class="btn btn--small"
                  :class="offer.offerType === 'open_buy'? 'seller' : 'buyer'"
                  @click.stop="offer.offerType === 'open_buy' || offer.offerType? toggleOfferId(offer.id, 'operate', 'sell') : toggleOfferId(offer.id, 'operate', 'buy')">

            Confirmar

          </button>

        </div>
      </div> -->

            <!-- <div v-else> -->

            <div class="offer__summary">
                <div class="summary-week">
                    <div>
                        <label> Entrega </label>
                    </div>
                    <div>
                        <strong>Semana {{ weekNumber(offer.week) }}</strong>
                    </div>
                    <div class="week-time">
                        {{ weekRange(offer.week) }}
                    </div>
                </div>

                <div class="summary-info">
                    <strong
                        :class="{
                            negotiable: offer.negotiableAttributes.quantity,
                        }"
                    >
                        <span class="wrapper"
                            >{{ showQuantityLeft }}
                            <span
                                v-if="offer.negotiableAttributes.quantity"
                                class="icon"
                            >
                                <img
                                    alt="Atributo negociable"
                                    src="@/assets/images/negotiate.svg"
                                />
                            </span>
                        </span>
                        {{
                            /^Capones$/i.test(offer.category.name)
                                ? "Capon"
                                : offer.category.name
                        }}
                    </strong>
                    <strong
                        :class="{
                            negotiable:
                                offer.negotiableAttributes.slaughterWeight,
                        }"
                    >
                        <span class="wrapper">
                            {{ localeNumber(offer.quality.slaughterWeight) }}
                            <span
                                v-if="
                                    offer.negotiableAttributes.slaughterWeight
                                "
                                class="icon"
                            >
                                <img
                                    alt="Atributo negociable"
                                    src="@/assets/images/negotiate.svg"
                                />
                            </span>
                        </span>
                        (± 5) Kgs
                    </strong>
                    <strong
                        :class="{
                            negotiable: offer.negotiableAttributes.price,
                        }"
                    >
                        $/Kg
                        <span class="wrapper">
                            {{ localePrice(offer.price) }}
                            <span
                                v-if="offer.negotiableAttributes.price"
                                class="icon"
                            >
                                <img
                                    alt="Atributo negociable"
                                    src="@/assets/images/negotiate.svg"
                                />
                            </span>
                        </span>
                        sin IVA
                    </strong>
                    <strong
                        v-if="offer.kilometers === 0 || offer.kilometers > 0"
                    >
                        <span class="wrapper">
                            {{ offer.kilometers ? offer.kilometers : "-" }} Kms
                        </span>
                    </strong>
                </div>

                <div class="offer-details">
                    <div class="info-grid">
                        <div v-if="offer.quality.performance">
                            <label> Rendimiento </label>
                            <strong
                                :class="{
                                    negotiable:
                                        offer.negotiableAttributes.performance,
                                }"
                            >
                                <span class="wrapper">
                                    {{ offer.quality.performance }} %
                                    <span
                                        v-if="
                                            offer.negotiableAttributes
                                                .performance
                                        "
                                        class="icon"
                                    >
                                        <img
                                            alt="Atributo negociable"
                                            src="@/assets/images/negotiate.svg"
                                        />
                                    </span>
                                </span>
                            </strong>
                        </div>

                        <div v-if="offer.quality.dorsalFat">
                            <label> Grasa dorsal </label>
                            <strong
                                :class="{
                                    negotiable:
                                        offer.negotiableAttributes.dorsalFat,
                                }"
                            >
                                <span class="wrapper">
                                    {{ offer.quality.dorsalFat }} mm
                                    <span
                                        v-if="
                                            offer.negotiableAttributes.dorsalFat
                                        "
                                        class="icon"
                                    >
                                        <img
                                            alt="Atributo negociable"
                                            src="@/assets/images/negotiate.svg"
                                        />
                                    </span>
                                </span>
                            </strong>
                        </div>

                        <div v-if="offer.quality.leanQuality">
                            <label> Calidad magro </label>
                            <strong
                                :class="{
                                    negotiable:
                                        offer.negotiableAttributes.leanQuality,
                                }"
                            >
                                <span class="wrapper">
                                    {{ offer.quality.leanQuality }}
                                    <span
                                        v-if="
                                            offer.negotiableAttributes
                                                .leanQuality
                                        "
                                        class="icon"
                                    >
                                        <img
                                            alt="Atributo negociable"
                                            src="@/assets/images/negotiate.svg"
                                        />
                                    </span>
                                </span>
                            </strong>
                        </div>

                        <div>
                            <label> Entrega en destino </label>
                            <strong
                                :class="{
                                    negotiable:
                                        offer.negotiableAttributes
                                            .deliveryAtDestination,
                                }"
                            >
                                <span class="wrapper">
                                    {{
                                        offer.deliveryAtDestination
                                            ? "Sí"
                                            : "No"
                                    }}
                                    <span
                                        v-if="
                                            offer.negotiableAttributes
                                                .deliveryAtDestination
                                        "
                                        class="icon"
                                    >
                                        <img
                                            alt="Atributo negociable"
                                            src="@/assets/images/negotiate.svg"
                                        />
                                    </span>
                                </span>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="offer__details" v-show="offerId">
                <div class="info-grid">
                    <div>
                        <label> Fecha de publicación </label>
                        <strong>
                            {{ localeDate(offer.publishedAt) }}
                        </strong>
                    </div>

                    <div>
                        <label> Fecha de vigencia </label>
                        <strong>
                            {{ localeDate(offer.dueAt) }}
                        </strong>
                    </div>

                    <div>
                        <label> Forma de pago </label>
                        <strong>
                            {{ offer.paymentMethod }}
                        </strong>
                    </div>

                    <div>
                        <label> Plazo de pago </label>
                        <strong>
                            {{ offer.paymentDeadline }}
                        </strong>
                    </div>

                    <div>
                        <label> Resolución de conflictos </label>
                        <strong>
                            {{ offer.conflictResolution }}
                        </strong>
                    </div>

                    <div class="secure-payment">
                        <label> Pago seguro </label>
                        <strong
                            :class="{
                                negotiable:
                                    offer.negotiableAttributes.securePayment
                                        .lock,
                            }"
                        >
                            <span class="wrapper">
                                {{ offer.securePayment ? "Sí" : "No" }}
                                <span
                                    v-if="
                                        offer.negotiableAttributes.securePayment
                                            .lock
                                    "
                                    class="icon"
                                >
                                    <img
                                        alt="Atributo negociable"
                                        src="@/assets/images/negotiate.svg"
                                    />
                                </span>
                            </span>
                        </strong>
                    </div>

                    <div class="secure-payment">
                        <label> Pago AgroNación </label>
                        <strong
                            :class="{
                                negotiable:
                                    offer.negotiableAttributes.securePayment
                                        .lock,
                            }"
                        >
                            <span class="wrapper">
                                {{ offer.agroNacionPayment ? "Sí" : "No" }}
                            </span>
                        </strong>
                    </div>

                    <template v-if="offer.securePayment">
                        <div
                            class="secure-payment-percentage"
                            v-if="offer.securePayment.percentage"
                        >
                            <label> Porcentaje de pago seguro </label>
                            <strong
                                :class="{
                                    negotiable:
                                        offer.negotiableAttributes.securePayment
                                            .percentage,
                                }"
                            >
                                <span class="wrapper">
                                    {{ offer.securePayment.percentage }} %
                                    <span
                                        v-if="
                                            offer.negotiableAttributes
                                                .securePayment.percentage
                                        "
                                        class="icon"
                                    >
                                        <img
                                            alt="Atributo negociable"
                                            src="@/assets/images/negotiate.svg"
                                        />
                                    </span>
                                </span>
                            </strong>
                        </div>

                        <div
                            class="secure-payment-lapse"
                            v-if="offer.securePayment.lapse"
                        >
                            <label>
                                Fecha de transferencia de pago seguro
                            </label>
                            <strong
                                :class="{
                                    negotiable:
                                        offer.negotiableAttributes.securePayment
                                            .lapse,
                                }"
                            >
                                <span class="wrapper">
                                    {{ offer.securePayment.lapse }} hs
                                    <span
                                        v-if="
                                            offer.negotiableAttributes
                                                .securePayment.lapse
                                        "
                                        class="icon"
                                    >
                                        <img
                                            alt="Atributo negociable"
                                            src="@/assets/images/negotiate.svg"
                                        />
                                    </span>
                                </span>
                            </strong>
                        </div>
                    </template>
                </div>

                <vs-divider />

                <div>
                    <label>Observaciones</label>
                    <strong>
                        {{
                            offer.description
                                ? offer.description
                                : "Sin observaciones."
                        }}
                    </strong>
                </div>

                <div class="offer-operations" v-if="offerAction != ''">
                    <vs-divider />
                    <!-- Form negociación -->
                    <NegotiationForm
                        ref="negotiationForm"
                        v-if="offerAction === 'negotiate'"
                        :offer="offer"
                        :buttons="false"
                        :negotiation-msg="negotiationMsg"
                    />

                    <!-- If user has multiple stablishments -->
                    <template v-if="originList.length > 1">
                        <div class="establishment-list">
                            <h4>Establecimiento</h4>
                            <p>
                                Seleccione el establecimiento con el cual desea
                                operar en esta oferta.
                            </p>

                            <div
                                class="input-group"
                                v-if="originList.length > 1"
                            >
                                <select
                                    name="establishmentId"
                                    v-validate="'required'"
                                    :danger="this.errors.has('establishmentId')"
                                    v-model="establishmentId"
                                    :class="{ changed: !!establishmentId }"
                                >
                                    <option value="">
                                        Establecimiento
                                        {{
                                            offer.offerType !== "sell"
                                                ? "destino"
                                                : "origen"
                                        }}
                                    </option>
                                    <option
                                        :key="index"
                                        :value="item.id"
                                        :text="item.name"
                                        v-for="(item, index) in originList"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                                <label for="establishmentId"
                                    >Establecimiento
                                    {{
                                        offer.offerType !== "sell"
                                            ? "destino"
                                            : "origen"
                                    }}</label
                                >
                                <div
                                    class="
                                        con-text-validation
                                        span-text-validation-danger
                                        vs-input--text-validation-span
                                    "
                                >
                                    <span>
                                        {{
                                            this.errors.first("establishmentId")
                                        }}</span
                                    >
                                </div>
                            </div>
                            <p v-else>
                                {{ originList[0].name }}
                            </p>
                        </div>
                    </template>
                    <div
                        v-if="userCanOperate(offer)"
                        class="negotiation-actions"
                        :class="{
                            center:
                                originList.length <= 1 &&
                                offerAction != 'negotiate',
                        }"
                    >
                        <h4>Confirmación</h4>
                        <div class="d-flex justify-content-center">
                            <p class="text-left">
                                <vs-icon
                                    class="font-size-12-px color-item-offer"
                                />
                                - Por favor verifique los datos de la oferta
                                antes de confirmar la operación. <br />
                                <vs-icon
                                    class="font-size-12-px color-item-offer"
                                />
                                - La contraparte también deberá Confirmarla.<br />
                                <vs-icon
                                    class="font-size-12-px color-item-offer"
                                />
                                - Tiene tiempo para cancelar la operación, hasta
                                que la contraparte también la confirme.
                            </p>
                        </div>

                        <div v-if="offerAction != 'negotiate'">
                            <button
                                class="btn btn-secondary"
                                @click="clearOffer()"
                            >
                                Cancelar
                            </button>
                            <button
                                class="btn bt---inverted"
                                :class="
                                    offer.offerType === 'open_buy'
                                        ? 'sell'
                                        : 'buy'
                                "
                                @click="takeActionOnOffer"
                                onClick="this.disabled=true; setTimeout(()=>{this.disabled=false},300)"
                                type="flat"
                                icon="check"
                            >
                                {{
                                    offer.offerType === "open_buy"
                                        ? "Vender"
                                        : "Comprar"
                                }}
                            </button>
                        </div>
                        <div v-else>
                            <button
                                class="btn btn-secondary"
                                @click="clearOffer()"
                            >
                                Cancelar
                            </button>
                            <button
                                class="btn bt---inverted negotiate"
                                data-test="button-sendNegotiation"
                                @click="startNegotiation"
                                type="flat"
                                icon="check"
                            >
                                Negociar
                            </button>
                        </div>
                    </div>
                    <div
                        v-else
                        class="negotiation-actions"
                        :class="{
                            center:
                                originList.length <= 1 &&
                                offerAction != 'negotiate',
                        }"
                    >
                        <button class="btn btn-secondary" @click="clearOffer()">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="offerAction === ''" class="summary-actions">
                <button
                    data-test="button-negotiation"
                    v-if="
                        hasAnyTrue(offer.negotiableAttributes) &&
                        userCanOperate(offer)
                    "
                    class="btn btn--small negotiate"
                    type="flat"
                    icon="close"
                    @click="toggleOfferId(offer.id, 'negotiate')"
                >
                    Negociar
                </button>
                <button
                    v-if="userCanOperate(offer)"
                    data-test="button-buy"
                    class="btn btn--small"
                    :class="offer.offerType === 'open_buy' ? 'seller' : 'buyer'"
                    @click="
                        offer.offerType === 'open_buy' || offer.offerType
                            ? toggleOfferId(offer.id, 'operate', 'sell')
                            : toggleOfferId(offer.id, 'operate', 'buy')
                    "
                >
                    {{
                        offer.offerType === "open_buy" ||
                        offer.offerType === "direct_buy"
                            ? "Vender"
                            : "Comprar"
                    }}
                </button>
                <button
                    class="btn btn--small"
                    :class="offer.offerType === 'open_buy' ? 'seller' : 'buyer'"
                    @click="
                        offer.offerType === 'open_buy' || offer.offerType
                            ? toggleOfferId(offer.id, 'operate', 'sell')
                            : toggleOfferId(offer.id, 'operate', 'buy')
                    "
                    v-else
                >
                    Ver más
                </button>
            </div>
            <!-- </div> -->
        </div>
        <vs-popup
            title="Pago Agro Nación"
            :active.sync="confirmPopup"
            :button-close-hidden="true"
            class="confirm-action agronacion"
        >
            <img
                alt="Logo Agronación"
                src="@/assets/images/logo_agronacion.png"
                class="logo-agronacion"
            />
            <div class="alert info">
                <vs-icon icon="warning"></vs-icon>
                <span
                    >Está confirmando una operación con Pago Agro Nación.</span
                >
            </div>

            <div class="footer">
                <button @click="confirmPopup = false" class="btn cancel">
                    Cancelar
                </button>
                <button
                    class="btn confirm"
                    @click="
                        agreeWithANP = true;
                        confirmPopup = false;
                    "
                >
                    Continuar
                </button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import NegotiationForm from "../components/offers/NegotiationForm.vue";
import { mapState } from "vuex";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

const administrableEstablishments = gql`
    query administrableEstablishments(
        $currentUserToken: String!
        $type: String
    ) {
        administrableEstablishments(
            currentUserToken: $currentUserToken
            type: $type
        ) {
            active
            id
            name
            number
            marketRole
        }
    }
`;

const createNegotiation = gql`
    mutation createNegotiation(
        $offerId: Int!
        $negotiableAttributes: NegotiationNegotiableAttributesInput!
        $offerorId: Int
        $senderId: Int
        $currentUserToken: String!
    ) {
        createNegotiation(
            offerId: $offerId
            negotiableAttributes: $negotiableAttributes
            offerorId: $offerorId
            senderId: $senderId
            currentUserToken: $currentUserToken
        ) {
            code
            message
            success
        }
    }
`;

export default {
    name: "market-table-body",
    props: {
        offer: {
            type: Object,
            required: true,
        },
    },
    components: {
        NegotiationForm,
    },
    watch: {
        offerId() {
            this.getOriginList();
        },

        agreeWithANP() {
            this.takeActionOnOffer();
        },
    },
    data() {
        return {
            originList: [],
            offerId: "",
            offerAction: "",
            negotiationMsg: "",
            establishmentId: "",
            confirmPopup: false,
            agreeWithANP: false,
            showConfirmation: false,
        };
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.User.currentUser,
        }),
        showQuantityLeft() {
            if (this.offer.quantityLeft != this.offer.quantity) {
                return `${this.offer.quantityLeft} de ${this.offer.quantity}`;
            }
            return this.offer.quantity;
        },
        offerLocation() {
            if (this.offer.displayLocation) {
                return this.offer.displayLocation;
            }
            return this.offer.offerType === "open_sell"
                ? `${this.offer.part.origin.state}, ${this.offer.part.origin.city}`
                : `${this.offer.part.destination.city}, ${this.offer.part.destination.state}`;
        },
    },
    methods: {
        toggleOfferId(id, action, type) {
            this.offerAction = action;
            //this.$refs.offerDetails.openHistory = false
            if (this.offerId && action === "") {
                this.offerId = "";
            } else {
                this.offerId = id;
                this.scrollToOffer(id);
                //this.$refs.offerDetails.open(id)
            }
        },
        clearOffer() {
            this.offerId = "";
            this.offerAction = "";
        },
        localeNumber(number) {
            return number.replace(".", ",");
        },
        scrollToOffer(id) {
            let yOffset = -16;
            let element = document.getElementById("offer-" + id);
            let y =
                element.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;
            // Tmp fix for mobile
            if (window.innerWidth < 991) {
                window.scrollTo({ top: y });
            } else {
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        },
        localePrice(price) {
            return price.toLocaleString("es", { minimumFractionDigits: 2 });
        },
        localeDate(str) {
            return new Date(Date.parse(str) + 3.6e6 * 3).toLocaleDateString();
        },
        hasAnyTrue(obj) {
            let res = false;
            Object.values(obj).forEach((vl) => {
                if (typeof vl == "boolean" && vl) {
                    res = true;
                }
                if (typeof vl == "object") {
                    Object.values(vl).forEach((v) => {
                        if (v) {
                            res = true;
                        }
                    });
                }
            });
            return res;
            //return !!Object.values(obj).find(q => q === true)
        },
        weekNumber(week) {
            return week.toString().slice(-2);
        },
        weekRange(offerWeek) {
            const week = offerWeek.toString().slice(-2);
            const year = offerWeek.toString().substr(0, 4);
            return `${this.getFirstDayOfWeek(
                week,
                year
            )} - ${this.getLastDayOfWeek(week, year)}`;
        },
        getFirstDayOfWeek(week, year) {
            var date = this.getDateOfWeek(week, year);
            date = date.toJSON().split("T")[0].split("-");
            return `${date[2]}/${date[1]}/${date[0]}`;
        },
        getLastDayOfWeek(week, year) {
            var date = this.getDateOfWeek(week, year);
            date.setDate(date.getDate() + 6);
            date = date.toJSON().split("T")[0].split("-");
            return `${date[2]}/${date[1]}/${date[0]}`;
        },
        getDateOfWeek(week, year) {
            let day = new Date(year, 0, 1 + (week - 1) * 7);
            let dayOfWeek = day.getDay();
            let weekStart = day;
            if (dayOfWeek <= 7) {
                weekStart.setDate(day.getDate() - day.getDay() + 1);
            } else {
                weekStart.setDate(day.getDate() + 8 - day.getDay());
            }
            if (year == 2023) {
                weekStart.setDate(weekStart.getDate() - (7));
            }
            return weekStart;
        },
        getOriginList() {
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(administrableEstablishments),
                        variables: {
                            currentUserToken:
                                localStorage.getItem("USER_TOKEN"),
                            type:
                                this.offer.offerType.split("_")[1] == "sell"
                                    ? "buyer"
                                    : "seller",
                        },
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.originList =
                            res.data.data.administrableEstablishments.filter(
                                (est) => est.active
                            );
                        if (this.originList.length === 1) {
                            this.establishmentId = this.originList[0].id;
                        }
                    }
                });
        },
        takeActionOnOffer() {
            if (this.offer.agroNacionPayment && !this.agreeWithANP) {
                this.confirmPopup = true;
                return;
            }

            if (!this.establishmentId) {
                this.$vs.notify({
                    title: "Para continuar debe seleccionar un establecimiento habilitado",
                    time: 5000,
                    //text: 'Por favor intente nuevamente',
                    color: "#DE3618",
                    position: "top-right",
                    icon: "error",
                });
                return;
            }

            // acá pongo los valores originales de la oferta
            let spCopy = Object.assign({}, this.offer.securePayment);
            delete spCopy.stage;

            let originalAttributes = {
                price: this.offer.price.toString(),
                quantity: this.offer.quantityLeft,
                deliveryAtDestination: this.offer.deliveryAtDestination,
                quality: this.offer.quality,
                securePayment: spCopy,
            };

            axios
                .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    query: print(createNegotiation),
                    variables: {
                        offerId: this.offerId,
                        offerorId: this.establishmentId,
                        senderId: this.currentUser.organizationId,
                        negotiableAttributes: originalAttributes,
                        currentUserToken: localStorage.getItem("USER_TOKEN"),
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        if (res.data.data.createNegotiation.success) {
                            this.offerId = "";
                            this.notify();
                            this.attributes = {};
                            this.$emit("get-offers");
                        } else {
                            if (
                                res.data.data.createNegotiation.code ==
                                "unauthorized"
                            ) {
                                this.$vs.notify({
                                    title: "No tiene permisos para realizar esta acción",
                                    time: 3000,
                                    //text: 'Por favor intente nuevamente',
                                    color: "#DE3618",
                                    position: "top-right",
                                    icon: "error",
                                });
                            } else {
                                this.error =
                                    res.data.data.createNegotiation.code;
                            }
                        }
                    }
                });
        },
        startNegotiation() {

            this.$refs.negotiationForm.$validator.validate().then((res) => {
                if (res) {
                    if (
                        !this.canNegotiate(
                            this.offer,
                            this.$refs.negotiationForm.adjustAttributesBeforeEmit()
                        )
                    ) {
                        this.negotiationMsg = "not_have_changes";
                        return false;
                    } else if (!this.establishmentId) {
                        this.$vs.notify({
                            title: "Para continuar debe seleccionar un establecimiento habilitado",
                            time: 3000,
                            //text: 'Por favor intente nuevamente',
                            color: "#DE3618",
                            position: "top-right",
                            icon: "error",
                        });
                        return;
                    }
                    this.negotiationMsg = "";
                    axios
                        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
                            query: print(createNegotiation),
                            variables: {
                                offerId: this.offerId,
                                offerorId: this.establishmentId,
                                senderId: this.currentUser.organizationId,
                                negotiableAttributes:
                                    this.$refs.negotiationForm.adjustAttributesBeforeEmit(),
                                currentUserToken:
                                    localStorage.getItem("USER_TOKEN"),
                            },
                        })
                        .then((res) => {
                            if (!res.data.errors) {
                                if (res.data.data.createNegotiation.success) {
                                    this.offerId = "";
                                    this.notify();
                                    this.attributes = {};
                                    this.$emit("get-offers");
                                } else {
                                    if (
                                        res.data.data.createNegotiation.code ==
                                        "unauthorized"
                                    ) {
                                        this.$vs.notify({
                                            title: "No tiene permisos para realizar esta acción",
                                            time: 3000,
                                            //text: 'Por favor intente nuevamente',
                                            color: "#DE3618",
                                            position: "top-right",
                                            icon: "error",
                                        });
                                    } else {
                                        this.error =
                                            res.data.data.createNegotiation.code;
                                    }
                                }
                            }
                        });
                }
            });
        },
        canNegotiate(obj, attributes = {}) {
            let keys = Object.keys(attributes);
            let can = false;
            keys.forEach((key) => {
                if (key == "securePayment") {
                    if (!attributes.securePayment) {
                        if (obj.securePayment) {
                            can = true;
                        }
                    } else {
                        if (!obj.securePayment) {
                            can = true;
                        } else {
                            let qKeys = Object.keys(attributes[key]);
                            qKeys.forEach((qk) => {
                                let qVal = attributes[key][qk];
                                if (qVal === false || !!qVal || qVal > 0) {
                                    if (obj[key][qk] != qVal) {
                                        can = true;
                                    }
                                }
                            });
                        }
                    }
                } else if (key === "quality") {
                    let qKeys = Object.keys(attributes[key]);
                    qKeys.forEach((qk) => {
                        let qVal = attributes[key][qk];
                        if (qVal === false || !!qVal || qVal > 0) {
                            if (obj[key][qk] != qVal) {
                                can = true;
                            }
                        }
                    });
                } else if (key === "quality") {
                } else {
                    var val = attributes[key];
                    if (val === false || !!val || val > 0) {
                        if (obj[key] != val) {
                            can = true;
                        }
                    }
                }
            });
            return can;
        },
        userCanOperate(offer) {
            const userRole = this.currentUser.offerRole;
            const offerType = offer.offerType;
            var band = false;
            band = userRole !== offerType.replace("open_", "").concat("er");
            return band;
        },
        notify(action) {
            if (action) {
                //  var title = 'Oferta ' + this.$t(`offer.action.${action}`)
                var title = "La operación ha sido exitosa";
                //  var text = 'La operación ha sido ' + this.$t(`offer.action.${action}`) + ' con éxito'
                var text = "";
            } else {
                var title = "Negociación enviada";
                var text = "Su negociación ha sido enviada.";
            }
            this.$vs.notify({
                title: title,
                time: 8000,
                text: text,
                color: "#50b83d",
                position: "top-right",
                icon: "check_circle",
            });
        },
        showPopupConfirmation() {
            this.showConfirmation = !this.showConfirmation;
        },
    },
};
</script>
